import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Component, Input, OnChanges, OnDestroy, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Registration } from "../../../../../models/registration";
import { RegistrationServiceLocation } from "../../../../../models/registration-service-location";
import { ServiceLocation } from "../../../../../models/service-location";
import { LocationService } from "../../../../../services/location-controller/location.service";
import { RegistrationServiceLocationControllerService } from "../../../../../services/location-controller/registration-service-location-controller.service";
import { ServiceLocationControllerService } from "../../../../../services/location-controller/service-location-controller.service";
import { Store } from "../../../../../services/store.service";
import {TranslatedBaseError} from "../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "registration-location",
  templateUrl: "./service-location-registration.component.html",
  providers: [ToastrService],
})
export class RegistrationServiceLocationComponent extends TranslatedBaseError implements OnChanges, OnInit, OnDestroy {

  @Input() public registration: Registration;
  @Input() public serviceId: string;
  @Input() public disabled: boolean = false;
  @Input() public determinantMapById: { [key: string]: string };
  public registrationServiceLocationList: RegistrationServiceLocation[] = [];
  public registrationServiceLocationListLength: number;
  public registrationServiceLocation: RegistrationServiceLocation;
  public serviceLocations: ServiceLocation[];
  public serviceLocation: ServiceLocation;
  public showDeterminant: boolean[] = [];
  public showDeterminantBuilder: boolean = false;
  public showList: boolean = false;
  public showServiceLocations: any = {};
  public addNew: boolean;
  public subscription: any;

  public searchLocationFilter: any;

  constructor(private serviceLocationControllerService: ServiceLocationControllerService,
              private registrationServiceLocationControllerService: RegistrationServiceLocationControllerService,
              public locationService: LocationService,
              public store: Store,
              toastr: ToastrService, public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.subscription = this.locationService.update.subscribe((data) => {
      if (data.update) {
        this.loadServiceLocations();
      }
    });
  }

  public ngOnChanges() {
    this.loadServiceLocations();
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public dropped(event: CdkDragDrop<RegistrationServiceLocation[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);

      // component logic
      if (!this.disabled) {
        this.registrationServiceLocationList.forEach((it, index, itemsArray) => {
          itemsArray[index].sortOrder = index;
          itemsArray[index].registrationId = this.registration.id;
        });
        this.sortRegistrationServiceLocationList();
      }
    }
  }

  public loadServiceLocations() {
    if (this.serviceId) {
      this.serviceLocationControllerService.getServiceLocations(this.serviceId).subscribe(
        (data) => {
          this.serviceLocations = data.sort((a, b) => {
            const nameA = a.name.toLowerCase();
            const nameB = b.name.toLowerCase();
            if (nameA < nameB) {
              return -1;
            }
          });
          this.loadRegistrationServiceLocationList();
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
      );
    }
  }

  public loadRegistrationServiceLocationList() {
    if (this.registration && this.registration.id) {
      this.registrationServiceLocationControllerService.getRegistrationServiceLocations(this.registration.id).subscribe(
        (data) => {
          const deletedItems = [];
          for (const existingItem of this.registrationServiceLocationList) {
            const keepThis = data.some((regDocLoc) => {
              return regDocLoc.id === existingItem.id;
            });
            if (!keepThis) { deletedItems.push(existingItem); }
          }
          deletedItems.forEach((item) => {
            this.registrationServiceLocationList.splice(this.registrationServiceLocationList.indexOf(item), 1);
          });
          for (const regDocLoc of data) {
            const existingItem = this.registrationServiceLocationList.find((item) => {
              return item.id === regDocLoc.id;
            });
            if (existingItem) {
              this.registrationServiceLocationList[this.registrationServiceLocationList.indexOf(existingItem)] = regDocLoc;
            } else {
              this.registrationServiceLocationList.push(regDocLoc);
            }
          }
          this.updateData(this.registrationServiceLocationList);
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public sortRegistrationServiceLocationList() {
    if (!this.disabled) {
      this.registrationServiceLocationControllerService.updateSortOrder(this.registrationServiceLocationList).subscribe(
        () => this.responseSuccessful("Registration Locations reordered!"),
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
      );
    }
  }

  public getNameOfServiceLocation(registrationServiceLocation: any) {
    let locationName: any;
    if (this.serviceLocations && this.serviceLocations.length > 0) {
      this.serviceLocations.forEach((thisServiceLocation: any) => {
        if (thisServiceLocation.id === registrationServiceLocation.serviceLocationId) {
          locationName = thisServiceLocation.name;
        }
      });
    }
    return locationName;
  }

  public hasDeterminant(item) {
    if (!item.jsonDeterminants || item.jsonDeterminants === '[{"type":"OR","items":[]}]') {
      return false;
    }
    return true;
  }

  public removeDeterminant(registrationServiceLocation: RegistrationServiceLocation, index: any) {
    if (!this.disabled) {
      registrationServiceLocation.jsonDeterminants = "";
      registrationServiceLocation.registrationId = this.registration.id;
      this.registrationServiceLocationControllerService.saveRegistrationServiceLocation(registrationServiceLocation).subscribe(
        () => {
          this.showDeterminant[index] = false;
          this.responseSuccessful("Collection place updated");
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public updateData(data: any) {
    if (!this.disabled) {
      this.showList = false;
      this.showDeterminant = new Array(data.length).fill(false);
      this.registrationServiceLocationList = data;
      this.registrationServiceLocationListLength = data.length;
      this.toggleRegistrationServiceLocationsFromServiceLocationList();
    }
  }

  public toggleRegistrationServiceLocationsFromServiceLocationList() {
    this.showServiceLocations = {};
    for (let j = this.serviceLocations.length - 1; j >= 0; j--) {
      this.showServiceLocations[this.serviceLocations[j].id] = true;
      for (let i = this.registrationServiceLocationList.length - 1; i >= 0; i--) {
        if (this.serviceLocations[j].id === this.registrationServiceLocationList[i].serviceLocationId) {
          this.showServiceLocations[this.serviceLocations[j].id] = false;
        }
      }
    }
  }

  public deleteRegistrationServiceLocation(isConfirmed: boolean, locationServiceId: string) {
    if (!this.disabled && isConfirmed) {
      this.registrationServiceLocationControllerService.deleteRegistrationServiceLocation(locationServiceId).subscribe(
        () => {
          this.loadRegistrationServiceLocationList();
          this.responseSuccessful("Collection place removed from registration");
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
      );
    }
  }

  public fixVisualEffectOnLocationSelected(serviceLocation): void {
    this.showList = false;
    const registrationServiceLocation = new RegistrationServiceLocation();
    registrationServiceLocation.serviceLocationId = this.serviceLocation.id;
    this.registrationServiceLocationList.push(registrationServiceLocation);
  }

  public addRegistrationServiceLocation(serviceLocation: ServiceLocation) {
    if (!this.disabled && this.registration !== undefined) {
      this.serviceLocation = serviceLocation;
      this.registrationServiceLocation = new RegistrationServiceLocation();
      this.registrationServiceLocation.serviceLocationId = this.serviceLocation.id;

      // for visual effect
      this.fixVisualEffectOnLocationSelected(serviceLocation);

      this.registrationServiceLocationControllerService.createServiceLocation(this.registration.id, this.registrationServiceLocation).subscribe(
        () => {
          this.loadServiceLocations();
          this.responseSuccessful("Location added to registration");
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
      );
    }
  }

  public openEdit(registrationServiceLocation: any, determinantView = false) {
    if (!this.disabled) {
      this.showDeterminantBuilder = determinantView;
      if (registrationServiceLocation) {
        for (let i = this.serviceLocations.length - 1; i >= 0; i--) {
          if (this.serviceLocations[i].id === registrationServiceLocation.serviceLocationId) {
            this.serviceLocation = this.serviceLocations[i];
          }
        }
        this.registrationServiceLocation = registrationServiceLocation;
        this.addNew = false;
      } else {
        this.serviceLocation = new ServiceLocation();
        if (this.searchLocationFilter !== undefined) {
          this.serviceLocation.name = this.searchLocationFilter.name;
        }
        this.registrationServiceLocation = new RegistrationServiceLocation();
        this.addNew = true;
      }
      this.updateEditData();
    }
  }

  public showOrAdd() {
    if (!this.disabled) {
      if (this.serviceLocations.length > 0 && this.registrationServiceLocationListLength !== this.serviceLocations.length) {
        this.showList = !this.showList;
      } else {
        this.openEdit(false);
      }
    }
  }

  public updateEditData() {
    if (!this.disabled) {
      this.showList = false;
      this.store.state.common.sections.type = "location";
      this.locationService.serviceId = this.serviceId;
      this.locationService.registration = this.registration;
      this.locationService.serviceLocation = JSON.parse(JSON.stringify(this.serviceLocation)); // mini-hack so the list doesn't update when working in edit layer
      this.locationService.registrationServiceLocation = JSON.parse(JSON.stringify(this.registrationServiceLocation)); // mini-hack so the list doesn't update when working in edit layer
      this.locationService.addNew = this.addNew;
      this.locationService.showDeterminantBuilder = this.showDeterminantBuilder;
      this.locationService.initEdit();
    }
  }

  public searchLocationChanged(value: any): void {
    this.searchLocationFilter = { name: value };
  }
}
